import { render, staticRenderFns } from "./ChatAvatar.vue?vue&type=template&id=6e57106d&scoped=true&"
import script from "./ChatAvatar.vue?vue&type=script&lang=js&"
export * from "./ChatAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ChatAvatar.vue?vue&type=style&index=0&id=6e57106d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e57106d",
  null
  
)

export default component.exports